import { createContext, useContext } from 'react'

/**
 * How far below the scrollport top a settings SECTION's own sticky header must pin.
 *
 * The Settings shell's "Settings" header is itself sticky. A section that wants a sticky
 * header of its own (My requests, whose search/filter/sort row should stay reachable down
 * a long list) cannot pin at 0 — it would park underneath the shell's header, invisible
 * but still covering the content it was meant to sit above.
 *
 * It cannot be a constant either. The shell header grows by the back-link row (47px) when
 * a cross-surface referrer brought the user in, so the offset differs between arriving
 * from the sidebar and arriving from the `?` dialog. `SettingsPage` already computes that
 * height for its own sub-nav positioning; this publishes the same number rather than
 * letting a second file re-derive it and drift.
 *
 * Lives in its own module, NOT in `SettingsPage.tsx`: that file imports every section
 * component (`<SupportPage scope="mine" />` among them), so a section importing back from
 * it would be an import cycle.
 *
 * Defaults to 0, which is correct for any page rendered outside the settings shell —
 * `/whats-new` uses the same sticky header at the top of the scrollport.
 */
export const SettingsStickyOffsetContext = createContext(0)

export const useSettingsStickyOffset = (): number => useContext(SettingsStickyOffsetContext)
